import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'nc-typing-text',
  templateUrl: './typing-text.component.html',
  styleUrls: ['./typing-text.component.less']
})
export class TypingTextComponent implements OnInit, OnDestroy {
  /** 展示的文本内容 */
  private _text: string = '';
  @Input()
  set ncText(value: string) {
    this._text = value;
    setTimeout(() => {
      this.start();
    });
  }
  get ncText(): string {
    return this._text;
  }
  /** 每个字符之间的延迟 */
  @Input() ncDelayMultiple: number = 100;
  /** 每个字符之间的间距 */
  @Input() ncGap: number = 0;
  /** 延迟 */
  @Input() ncDelay: number = 0;
  /** 是否在视图可见时才开始动画 */
  private _startOnView: boolean = false;
  @Input()
  set ncStartOnView(val: boolean | string) {
    this._startOnView = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncStartOnView(): boolean {
    return this._startOnView;
  }
  /** 是否只执行一次动画 */
  private _once: boolean = false;
  @Input()
  set ncOnce(val: boolean | string) {
    this._once = val !== null && val !== undefined && val !== false && val !== 'false';
  }
  get ncOnce(): boolean {
    return this._once;
  }

  displayedText: string = '';
  private observer: IntersectionObserver | null = null;
  private typingInterval: any = null;
  private timeout: any = null;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.clear();
  }

  private start(): void {
    this.clear();
    if (!this.ncStartOnView) {
      this.timeout = setTimeout(() => {
        this.startTyping();
      }, this.ncDelay);
    } else {
      this.setupIntersectionObserver();
    }
  }

  private clear(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  private setupIntersectionObserver(): void {
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.timeout = setTimeout(() => {
          this.startTyping();
        }, this.ncDelay);

        if (this.ncOnce) {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      } else if (!this.ncOnce) {
        this.endTyping();
      }
    },
      { threshold: 0.1 }
    );

    this.observer.observe(this.elementRef.nativeElement);
  }

  private startTyping(): void {
    let i = 0;

    this.typingInterval = setInterval(() => {
      if (i < this.ncText.length) {
        this.displayedText = this.ncText.substring(0, i + 1);
        i++;
      } else {
        clearInterval(this.typingInterval);
      }
    }, this.ncDelayMultiple);
  }

  private endTyping(): void {
    //若执行动画（startTyping）内部正在执行，则清除动画
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
    //若存在ncDelay，离开视图后，进入动画（startTyping）可能还未执行，则需要清除timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    //隐藏显示的文本
    this.displayedText = '';
  }
}
